module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.show) ? _c('article', {
    staticClass: "vux-1px-tb book",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.go($event)
      }
    }
  }, [_c('span', {
    staticClass: "vux-close book-close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.close($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "book-classification"
  }, [_c('i', {
    staticClass: "fa fa-css3",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("来自分类:" + _vm._s(_vm.classification))])]), _vm._v(" "), (_vm.img) ? _c('div', {
    staticClass: "book-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "book-title"
  }, [_c('h3', [_vm._v("\n      " + _vm._s(_vm.title) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "book-text",
    style: (_vm.seemore)
  }, [_c('p', [_vm._v(_vm._s(_vm.text))])]), _vm._v(" "), _c('div', {
    staticClass: "book-footer"
  }, [_c('a', {
    staticClass: "book-footer-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.more($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.see ? '点击收起' : '查看更多'))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-51223b03"}!./~/.1.0.61@vux-loader/src/template-loader.js!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/book.vue
// module id = 110
// module chunks = 1